import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    const reset = () => {
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      document.querySelectorAll(
        '.mirror-page, .solutions-page, .bfm-page, .branding-root'
      ).forEach((el) => { el.scrollTop = 0; });
    };
    // Fire immediately and again after paint to catch deferred layout shifts
    reset();
    const raf = requestAnimationFrame(reset);
    return () => cancelAnimationFrame(raf);
  }, [pathname]);
  return null;
};

export default ScrollToTop;
